import { State } from 'builder/features/virtualCoach/types'

export const API_ENDPOINT = `/ai_coach/v1/ai_coach/prompt`
export const CLIENT_STORAGE_KEY = 'virtual_coach_state'
export const ERROR_MESSAGE = 'builder.virtual_coach.error_message'
export const DEFAULT_STATE: State = [
  {
    role: 'assistant',
    urlLinks: [],
    content:
      "Hello and welcome! I’m your personal AI coach. I'm here to help you set goals, stay motivated, and navigate challenges. Whether you're looking for advice, support, or just a nudge in the right direction, I’ve got your back. What’s on your mind today?",
  },
]
